import TodoPage from "./TodoPage";

// Common To-Dos uses the same TodoPage component with isCommon flag
// This ensures visual parity between private and shared todo views
export default function CommonTodosPage({ sidebarOpen = true }) {
  return <TodoPage isCommon={true} sidebarOpen={sidebarOpen} />;
}
